module.exports = __webpack_public_path__ + "img/verify.40b7254e.svg";